import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {SearchRequest, SearchResponse} from '../model/model';
import {SearchRepository} from '../repositories/search.repository';

@Injectable()
export class SearchService {

  constructor(private searchRepository: SearchRepository) { }

  public getSearchResults(request: SearchRequest): Observable<SearchResponse> {
    return this.searchRepository.getSearchResults(request);
  }

}
